import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--restaurant-thumb-gap);
`;

export const Thumbnail = styled.picture`
  display: flex;
  align-items: center;
  justify-content: center;
  ${r('width', 48)}
  ${r('height', 48)}
  border-radius: var(--radius-thumb);
  background: var(--color-card-active);
  box-shadow: var(--shadow-thumbnail);
  backdrop-filter: var(--effect-glass-blur);
  -webkit-backdrop-filter: var(--effect-glass-blur);
  overflow: hidden;
`;

export const Logo = styled.img`
  ${r('width', 31)}
  ${r('height', 20)}
  object-fit: contain;
`;

export const Meta = styled.dl`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--restaurant-meta-gap);
  margin: 0;
`;

export const Name = styled.dt`
  margin: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-restaurant-name-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
`;

export const Type = styled.dd`
  margin: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-restaurant-type-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-muted);
`;
